import { createFileRoute } from '@tanstack/react-router';
import { Header } from '@/components/Header';
import { NotificationDetails } from '@/pages/NotificationDetails';

export const Route = createFileRoute(
  '/_authenticated/notifications/$notificationId'
)({
  component: NotificationDetailsPage,
});

function NotificationDetailsPage() {
  const { notificationId } = Route.useParams();

  return (
    <>
      <Header enableBack backTo="/notifications" fallbackTo="/notifications" />
      <NotificationDetails notificationId={notificationId} />
    </>
  );
}
